// First Block
function setRecentlyViewedPdp() {

  // Init Empty Array to push data
  const productArr = [];

  // Create a couple of variables
  let jsonResp,
    jsonRespArr,
    jsonRespArrStr;

  // Set the number how many products you want to capture
  const numberOfProduct = document.querySelector('#recently-viewed').getAttribute("data-value");

  // Now push the pdpData into Array so that we can use it
  productArr.push(pdpData);

  // Get the product title from pdpData
  const currPdpTitle = pdpData.productTitle;

  // Now Convert current page data into Strings which we already pushed in Array
  const pdpDataString = JSON.stringify(productArr);

  // Set the variable for sessionStorage
  const localData = sessionStorage.getItem('recently_viewed');

  if (currPdpTitle.trim() !== "") {
    // Second Block
    // first we need to check data if data is not there then store right // away
    if (localData == null) {
      sessionStorage.setItem('recently_viewed', pdpDataString);
    }

    // If data is there then we need to check couple of other conditions
    else if (localData != null) {

      // Create Variable for oldData or Previous page
      const oldPdpData = sessionStorage.getItem('recently_viewed');

      // Count the amount of data stored in strings so that we can remove // old products from the stack
      const countPdpData = (oldPdpData.match(/productTitle/g) || []).length;

      // we also need to check if user is not visiting page again
      const reVisitPdp = oldPdpData.includes(currPdpTitle);

      // Get old data, merged it with new data and store merged data
      if (countPdpData < numberOfProduct && reVisitPdp == false) {
        jsonResp = JSON.parse(oldPdpData);
        jsonRespArr = jsonResp.concat(productArr);
        jsonRespArrStr = JSON.stringify(jsonRespArr);
        sessionStorage.setItem('recently_viewed', jsonRespArrStr);
      }
      // If User visited more the numberOfProduct pages delete first page data
      else if (countPdpData >= numberOfProduct && reVisitPdp == false) {
        jsonResp = JSON.parse(oldPdpData);
        jsonResp.shift();
        jsonRespArr = jsonResp.concat(productArr);
        jsonRespArr = JSON.stringify(jsonRespArr);
        sessionStorage.setItem('recently_viewed', jsonRespArr);
      }
    }
  }
}

// Now we write all our function and it's time to execute it

setRecentlyViewedPdp();

// Set Variable for Local Storage Data
const localViewed = sessionStorage.recently_viewed;

// Third Block
function getRecentPdp() {

  // First let's convert sessionStorage data into object again
  const pdpData = JSON.parse(sessionStorage.getItem('recently_viewed'));

  // Create a empty Array
  const recentViewHtml = []

  // Loop through all the data and inject into HTML using ES6
  if (Array.isArray(pdpData) && pdpData.length > 0) {
    pdpData.forEach(function (item) {
      recentViewHtml.push(`
          <div class="grid__item slider__slide">
            <div class="card-wrapper product-card-wrapper underline-links-hover">
              <a class="full-unstyled-link" href="${item.productUrl}">
                <div class="card card--standard card--media">
                  <div class="card__inner color-scheme-2 gradient ratio">
                    <div class="card__media">
                      <div class="media media--transparent media--hover-effect">
                        ${item.productImg}
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </div>  
          </div>
        `)
    })

    recentViewHtml.reverse();
    recentViewHtml.splice(document.querySelector('#recently-viewed').getAttribute("data-value"));

    // Now consolidate the data
    const recentBlock = `${recentViewHtml.join('')}`

    document.querySelector('.recently-viewed__heading').style.display = 'block';

    // Inject into PDP page
    const contentBlock = document.querySelectorAll('.js-recentPdpBlock');

    // Push the data
    contentBlock.forEach(element => {
      element.innerHTML = recentBlock;
    })

  }
}

// Execute this function on DOM content load
document.addEventListener('DOMContentLoaded', () => {
  getRecentPdp();
});